export default "__VITE_ASSET__d4060173__"